module.exports = __webpack_public_path__ + "img/roetzel.00ab9b86.png";